import {useEffect, useState} from "react"

import DropDown from "./DropDown"

const ComputedSelect = ({entity, fld}) => {
    const [prompt, setPrompt] = useState(null)

    useEffect(
        () => {
            const tmp = fld.valueGetter(entity, fld)
            if (tmp) {
                setPrompt(tmp)
            }
        }, [entity, fld]
    )

    if (!prompt) {
        return (<span>No distinguishing prompts</span>)
    }
    return (
        <DropDown
            entity={entity}
            fld={{...fld, options: prompt.answers.map(a => [a.id, a.abbrLabel])}}
        />
    )
}

export default ComputedSelect